import useSWR from "swr"
import {API_PROJECTS} from "../constants/apiUrls"

export default function useCountStProjects(params) {
    const url = `${API_PROJECTS}/count?` + (params === "my-projects" ? "public=false" : params === "shared-projects" ? "public=true" : params === "recycle-bin" ? "deleted=true" : null)
    const {data, mutate, error} = useSWR(url)

    return {
        countStProjects: data,
        mutateCountStProjects: mutate,
        isLoadingCountStProjects: !error && !data,
        isErrorCountStProjects: error
    }
}